// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_count_votes.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_count_votes',
	field: function() { return 'g.game_players_count' }
})
